import { FlagState } from '../libs';

export const FLAG_SUP_FEATURES: FlagState = {
  RELEASE_MOBIO_CHAT: false,
  MML_NO_PAYMENT: false,
  WEBAPP_RETURN_REQUEST: true,
  EDIT_ORDER: false,
  epic_ecom_296: false,
  epic_ecom_269: false,
  epic_omni_633: false,
  epic_ecom_368: false,
  epic_ecom_366: false,
};
